(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-bet-placed-extended.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-bet-placed-extended.js');
"use strict";


const {
  getBetslipCount
} = svs.sportsbook.sbtech_api_impl.betslip;
const {
  getTitleFromBet,
  parseToDecimals
} = svs.sportsbook.sbtech_api_impl.utils;
const {
  loader,
  dialog
} = svs.components;
const ERROR_INCOMPLETE_BET_AMOUNT_TIMEOUT = 5000;
let temporaryBets = [];
let expectedAmountOfBets;
let errorTimeout;
function reset() {
  temporaryBets = [];
  loader.hide();
}
function openSelfserviceContainer() {
  clearTimeout(errorTimeout);
  const wagers = temporaryBets.map(bet => ({
    bets: [bet]
  }));
  reset();
  const products = [];
  wagers.forEach(wager => {
    const productFlag = 'oddset'; 

    const productTitle = getTitleFromBet(wager.bets[0]);
    const cost = wager.bets[0].totalDeposit;
    const description = "Odds: ".concat(svs.utils.format.Odds(wager.bets[0].odds));
    products.push(svs.components.selfserviceCart.generateProductItem({
      wagers: wager,
      isLive: false,
      headers: {
        source: 'SvS:LB:SBTech'
      },
      productFlag,
      cost,
      description,
      productTitle
    }));
  });
  if (products.length === 1) {
    svs.components.selfserviceCart.getCartInstance().actions.addItem(products[0], () => {});
  } else if (products.length > 1) {
    svs.components.selfserviceCart.getCartInstance().actions.addItems(products, () => {});
  }
}
function handleIncompleteBetAmountError() {
  dialog.api.add(new dialog.Confirm({
    type: dialog.type.ERROR,
    title: 'Något gick fel',
    message: [{
      text: 'Något gick fel när dina vad skulle sparas. Testa att lägga dem igen.',
      type: dialog.message.TEXT
    }],
    actions: [{
      title: 'Ok'
    }]
  }));
  svs.sportsbook.sbtech_api_impl.logger.warn("Received only ".concat(temporaryBets.length, " bets out of the expected ").concat(expectedAmountOfBets, " bets."));
  reset();
}
function restartErrorTimer() {
  clearTimeout(errorTimeout);
  errorTimeout = setTimeout(handleIncompleteBetAmountError, ERROR_INCOMPLETE_BET_AMOUNT_TIMEOUT);
}
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_betPlacedExtended = () => _ref => {
  let {
    betslipMode,
    numberOfBets,
    totalDeposit,
    totalGain,
    selections = [],
    odds,
    oddsStyle,
    betType,
    totalBetCount
  } = _ref;
  if (svs.core && svs.core.config && svs.core.config.data && svs.core.config.data.svsconfig && svs.core.config.data.svsconfig.isSelfService) {
    const bet = {
      betslipMode,
      numberOfBets,
      odds: parseToDecimals(odds),
      oddsStyle,
      selections: selections.map(selection => typeof selection === 'string' ? selection : selection.id),
      totalDeposit,
      totalGain: parseToDecimals(totalGain, ','),
      isSportsbook: true,
      betType
    };
    temporaryBets.push(bet);
    const isExpectingNoMoreBets = totalBetCount === numberOfBets || betslipMode && betslipMode !== 'single';
    if (isExpectingNoMoreBets) {
      openSelfserviceContainer();
      return;
    }
    loader.show();
    restartErrorTimer();

    if (temporaryBets.length === 1) {
      expectedAmountOfBets = totalBetCount || getBetslipCount();
    }

    if (temporaryBets.length === expectedAmountOfBets) {
      openSelfserviceContainer();
    }
  }
};

 })(window);